export default ( dataToTracking ) => {
  return {
    event: dataToTracking.event, // Dinamic Data
    actionType: dataToTracking.actionType, // Dynamic Data
    flightType: dataToTracking.flightType,
    pnr: dataToTracking.pnr, // Dynamic Data
    FromOrigin: dataToTracking.FromOrigin,
    FromDestiny: dataToTracking.FromDestiny,
    ToOrigin: dataToTracking.ToOrigin,
    toDestiny: dataToTracking.toDestiny,
    pnrCreationDate: dataToTracking.pnrCreationDate,
    FromDepartureD: dataToTracking.FromDepartureD,
    FromReturnD: dataToTracking.FromReturnD,
    ToDepartureD: dataToTracking.ToDepartureD,
    ToReturnD: dataToTracking.ToReturnD,
  };
};
  